'use strict';
import angular from 'angular'

function MapController($rootScope, $scope, $timeout, $compile, objectMakerFactory, dataHolderFactory, googleMapsInitializerFactory, heatMapOverlayFactory, usSpinnerService, dataRequestService, appSettings, constantSettings, $http, urlFactory, parameterFactory, parameterNames, overlappingService) {
  const self = this;
  let snappedCoordinates = [];
  let currentInfoWindow;
  let currentMarkerId;

  this.getCurrentPosition = function(callback) {
//			usSpinnerService.spin('spinner-1');
    const defaultCoordinate = appSettings.getDefaultCoordinate();
    callback(new google.maps.LatLng(defaultCoordinate.latitude, defaultCoordinate.longitude));
    navigator.geolocation.getCurrentPosition(function() {
//				usSpinnerService.stop('spinner-1');
      callback(new google.maps.LatLng(defaultCoordinate.latitude, defaultCoordinate.longitude));
    }, function() {
      usSpinnerService.stop('spinner-1');
      callback(new google.maps.LatLng(defaultCoordinate.latitude, defaultCoordinate.longitude));
    }, {
      maximumAge: constantSettings.maximumMapDataAge, timeout: constantSettings.mapUpdateTimeout, enableHighAccuracy: true
    });
  };

  const prepareViewForDetails = function(data, isClickMarker) {
    dataHolderFactory.updateContractDetails(data);
    $rootScope.$emit('restoreFloatingBox');
    $timeout(function() {
      $rootScope.appControl.showDetailsBox = isClickMarker; 
      $rootScope.appControl.showFloatingControl = isClickMarker;
    }, constantSettings.fasterDelayTimeout);
  };

  const prepareViewForDetailsByContracts = function(data) {
    prepareViewForDetails(data, false);
  };

  const clearAllMarkers = function() {
    angular.forEach($scope.mapViewControl.contractsPins, function(contractPin) {
      contractPin.setMap(null);
      self.oms.removeMarker(contractPin);
    });
    $scope.mapViewControl.contractsPins = [];
  };

  const removerAnimacoes = function() {
    clearAllMarkers();
    self.setMapContracts();

  };

  const animaMarcadoresPorObra = function(obra) {

    const bounds = new google.maps.LatLngBounds();

    const selectedsPins = [];

    angular.forEach($scope.mapViewControl.contractsPins, function(pinoContrato) {
      if (obra.nuTitulo === pinoContrato.id && ($scope.appControl.animaTodasObra || (obra.cdLote && pinoContrato.lotes.indexOf(obra.cdLote.toString() !== -1)))) {
        const local = new google.maps.LatLng(pinoContrato.getPosition().lat(),
          pinoContrato.getPosition().lng());
        bounds.extend(local);
        selectedsPins.push(pinoContrato);
      } else {
        pinoContrato.setMap(null);
      }
    });

    limparLinhas();

    if (obra.roads) {
      const roads = obra.roads;

      const groupCoordinates = roads.map(function(road) {
        return road.coordinates;
      });
      var allCoordinates = [];
      angular.forEach(groupCoordinates, function(coordinates) {
        allCoordinates.push.apply(allCoordinates, coordinates);

        // TRECHO A COMENTAR PARA USAR A API SNAP TO ROADS
        angular.forEach(coordinates, function(coordenada) {
          const latlng = { lat: coordenada.latitude, lng: coordenada.longitude };
          adicionaCoordenadaLinha(latlng);
        });

        drawSnappedPolyline();
        snappedCoordinates = [];
        // FIM DO TRECHO
      })
    }

    let minLat = 90;
    let maxLat = -90;
    let minLong = 180;
    let maxLong = -180;

    if (allCoordinates && allCoordinates.length > 0) {
      angular.forEach(allCoordinates, function(coordenada) {
        minLat = Math.min(minLat, coordenada.latitude);
        maxLat = Math.max(maxLat, coordenada.latitude);
        minLong = Math.min(minLong, coordenada.longitude);
        maxLong = Math.max(minLong, coordenada.longitude);
      });

      const minLocal = new google.maps.LatLng(minLat, minLong);
      const maxLocal = new google.maps.LatLng(maxLat, maxLong);
      bounds.extend(minLocal);
      bounds.extend(maxLocal);
    }

    if (!bounds.isEmpty()) {
      $scope.mapViewControl.map.fitBounds(bounds);
      $scope.mapViewControl.map.panToBounds(bounds);
    }

    // COMENTADO PELA REMOÇÃO DA API SNAP TO ROAD
    // runSnapToRoad(groupCoordinates);

    //$scope.mapViewControl.markerCluster.clearMarkers();
    angular.forEach(selectedsPins, function(pin) {
      //pin.setMap($scope.mapViewControl.map);
      pin.setAnimation(google.maps.Animation.BOUNCE);
    });
    $timeout(function() {
      removerAnimacoes();
      self.setContractMarkers(obra.nuTitulo);
    }, constantSettings.animationTimeout);
  };

  function adicionaCoordenadaLinha(latlng) {
    snappedCoordinates.push(latlng);
  }

  const animaMarcadoresPorContrato = function(contract) {
    if (contract.construction.length === 0) {
      return;
    }

    usSpinnerService.spin('spinner-1');
    animaMarcadoresPorObra({
      nuTitulo: contract.id,
      cdLote:   contract.construction.id,
      roads:    prepareMapAndReturnRoadsContract(contract)
    });
    usSpinnerService.stop('spinner-1');

  };

  var prepareMapAndReturnRoadsContract = function(contract) {
    $scope.appControl.animaTodasObra = true;
    $rootScope.appControl.currentContract = contract.id;
    const allRoads = [];
    angular.forEach(contract.construction, function(construction) {
      allRoads.push.apply(allRoads, construction.roads);
    });

    return allRoads;
  };

  self.countClick = 0;
  this.setEventForMarker = function() {
    self.oms.addListener('click', function(marker) {
      gerarContornoDeUmaCidadeNoMapa(marker.coordinate.lat, marker.coordinate.lng);
      currentMarkerId = marker.markerId;
      const obra = {
        nuTitulo: marker.id,
        cdLote:   marker['cdLote']
      };
      marker.get('id');
//			(!$rootScope.appControl.showFilterBox) && $scope.mapViewControl.map.panTo(marker.getPosition());
      usSpinnerService.spin('spinner-1');
      dataRequestService.getContractDetails(marker.get('id')).then(function(data) {
//				self.setZoomOnClick();
        $rootScope.appControl.showingInMap = false;
        prepareViewForDetails(data, true);

        obra.roads = prepareMapAndReturnRoadsContract(data);
        animaMarcadoresPorObra(obra);

        usSpinnerService.stop('spinner-1');
      }, function() {
        usSpinnerService.stop('spinner-1');
      });
    });
  };

  this.setZoomOnClick = function() {
    $scope.mapViewControl.map.setZoom(constantSettings.maxZoom);
  };

  function gerarContornoDeUmaCidadeNoMapa(latitude, longitude) {
    const gerarContornoDeUmaCidadeNoMapa = appSettings.config.show.gerarContornoDeUmaCidadeNoMapa;

    if (!gerarContornoDeUmaCidadeNoMapa) {
      return;
    }

    let city;
    const geocoder = new google.maps.Geocoder();

    // Encontrar municipio a partir das coordenadas informadas
    geocoder.geocode({ 'location': { lat: latitude, lng: longitude } }, function(results, status) {

      if (status === google.maps.GeocoderStatus.OK) {

        results.forEach(function(element) {
          element.address_components.forEach(function(element2) {
            element2.types.forEach(function(element3) {
              switch (element3) {
                case 'administrative_area_level_2':
                  city = element2.long_name;
                  break;
                case 'locality':
                  city = element2.long_name;
                  break;
              }
            })
          });
        });

        // Centralizar ao clicar no mapa
        const pointOfMap = new google.maps.LatLng(latitude, longitude);
        $scope.mapViewControl.map.setCenter(pointOfMap);
        $scope.mapViewControl.map.setZoom(constantSettings.maxZoomOnClick);

        // Buscar por nome do munipio as coordenadas para desenhar contorno no mapa
        usSpinnerService.spin('spinner-1');
        dataRequestService.getCoordenadasMunicipio(city).then(function(result) {
          usSpinnerService.stop('spinner-1');

          $scope.cityPolygon.setMap(null);

          const coordenadasMunicipio = JSON.parse(result.coordenadas);

          $scope.cityPolygon = new google.maps.Polygon({
            paths:         coordenadasMunicipio,
            strokeColor:   '#028181',
            strokeOpacity: 0.8,
            strokeWeight:  1,
            fillOpacity:   0.1
          });

          $scope.cityPolygon.setMap($scope.mapViewControl.map);

          $scope.polygonInfowindow.setContent(city);
          $scope.polygonInfowindow.setPosition(pointOfMap);
          $scope.polygonInfowindow.open($scope.mapViewControl.map);

        }, function(error) {
          usSpinnerService.stop('spinner-1');
          console.log(error);
        });
      }
    });
  }

  $rootScope.$on('clearPolygons', function() {
    $scope.cityPolygon.setMap(null);
    if ($scope.polygonInfowindow) {
      $scope.polygonInfowindow.close();
    }
  });

  this.configureView = function() {
    googleMapsInitializerFactory.mapsInitialized.then(function() {
      try {

        $scope.mapViewControl.map = new google.maps.Map(document.getElementById('map'), objectMakerFactory.viewObjectControlForMapOptions());
        $scope.mapViewControl.geocoder = new google.maps.Geocoder();
        $scope.mapViewControl.serviceMap = new google.maps.places.PlacesService($scope.mapViewControl.map);

        //self.oms = new OverlappingMarkerSpiderfier($scope.mapViewControl.map);

        $scope.cityPolygon = new google.maps.Polygon();
        $scope.estadoPolygon = new google.maps.Polygon();

        $rootScope.$broadcast('initSearchController');
        overlappingService.loadOverlapping().then(function success() {

          self.oms = new OverlappingMarkerSpiderfier($scope.mapViewControl.map);
          const paramUfClient = parameterFactory.getParameter(parameterNames.PRM_UF_CLIENT).value;

          const widthApp = angular.element(document.getElementById('idDivRenderApp'))[0].offsetWidth;
          const paramShowContractOnLoadMap = parameterFactory.getParameter(parameterNames.PRM_SHOW_CONTRACT_ONLOAD_MAP).value;

          if (paramShowContractOnLoadMap === 'S' && widthApp >= 767)
            $scope.$emit('openViewWithContext', 'CONTRACTS');
          
          dataRequestService.getCoordenadasUf(paramUfClient).then(function(result) {
            const coordenadasUf = JSON.parse(result.coordenadas);

            // Construct the polygon
            $scope.estadoPolygon = new google.maps.Polygon({
              paths:         coordenadasUf,
              strokeColor:   '#028181',
              strokeOpacity: 0.5,//0.8,
              strokeWeight:  2,
              fillOpacity:   0.05//0.1//0.35
            });

            //Capture click
            $scope.polygonInfowindow = new google.maps.InfoWindow();

            $rootScope.$emit('mapaCarregado');

            google.maps.event.addListener($scope.estadoPolygon, 'click', function(args) {
              const latitude = args.latLng.lat();
              const longitude = args.latLng.lng();

              if ($scope.polygonInfowindow) {
                $scope.polygonInfowindow.close();
              }

              gerarContornoDeUmaCidadeNoMapa(latitude, longitude);


            });

            $scope.estadoPolygon.setMap($scope.mapViewControl.map);

          }, function(error) {
            usSpinnerService.stop('spinner-1');
            console.log(error);
          });

          self.addEventMap();
          self.addEventStreetView();
          self.setMapContracts();
          self.setEventForMarker();

          if ($rootScope.appControl.urlKml) {
            new google.maps.KmlLayer({
              url:       $rootScope.appControl.urlKml,
              map:       $scope.mapViewControl.map,
              clickable: false
            });
            delete $rootScope.appControl.urlKml;
          }

        });

      } catch(err) {
        console.log('map not initialized');
        return;
      }
      self.getCurrentPosition(defaultCallbackPosition);
    });
    parameterFactory.initParameters(constantSettings.systems.SMO);
  };

  $scope.seeDetails = function() {
    $rootScope.appControl.showDetailsBox = true;
    $rootScope.appControl.showFloatingControl = false;
    closeCurrentInfoWIndows();
    /*angular.forEach($scope.mapViewControl.contractsPins, function(contractPin){
            if(contractPin.id === Idmarker && contractPin.infoWindow){
                contractPin.infoWindow.close();
            }

        });*/
  };

  $rootScope.$on('closeInfoView', function() {
    closeCurrentInfoWIndows();
  });

  var closeCurrentInfoWIndows = function() {
    if (currentInfoWindow) {
      currentInfoWindow.close();
    }
  };

  const addInfoWindow = function(marker) {

    const contract = dataHolderFactory.getSavedContractDetails();
    const htmlCompiled = $compile(objectMakerFactory.htmlObjectForInfoWindow(contract).html)($scope);
    const infowindow = new google.maps.InfoWindow({
      content: htmlCompiled[0]
    });
    marker.infoWindow = infowindow;
    currentInfoWindow = infowindow;
    google.maps.event.addListener(infowindow, 'domready', function() {

      // Referência ao DIV que recebe o conteúdo da infowindow recorrendo ao jQuery
      const iwOuter = $('.gm-style-iw');
      // Desloca a infowindow 50px para a direita
      iwOuter.parent().parent().css({ left: '50px' });

      /* Uma vez que o div pretendido está numa posição anterior ao div .gm-style-iw.
              * Recorremos ao jQuery e criamos uma variável iwBackground,
              * e aproveitamos a referência já existente do .gm-style-iw para obter o div anterior com .prev().
              */
      const iwBackground = iwOuter.prev();

      // Remover o div da sombra do fundo
      iwBackground.children(':nth-child(2)').css({ 'display': 'none' });

      // Remover o div de fundo branco
      iwBackground.children(':nth-child(4)').css({ 'display': 'none' });
      // Desloca a sombra da seta a 50px da margem esquerda
      iwBackground.children(':nth-child(1)').attr('style', function(i, s) {
        return s + 'left: 50px !important;'
      });

      // Desloca a seta a 50px da margem esquerda
      iwBackground.children(':nth-child(3)').attr('style', function(i, s) {
        return s + 'left: 50px !important;'
      });
      // Altera a cor desejada para o contorno da cauda.
      // O contorno da cauda é composto por dois descendentes do div que contem a cauda.
      // O método .find('div').children() faz referência a todos os div que sejam os descendentes directos do div anterior.
      iwBackground.children(':nth-child(3)').find('div').children().css({ 'box-shadow': 'rgba(72, 181, 233, 0.6) 0px 1px 6px', 'z-index': '1' });
      // Aproveitando a referência já criada ao div .gm-style-iw com a variável iwOuter.
      // Criamos uma nova variável iwCloseBtn.
      // Utilizando o método .next() do JQuery referenciamos o div seguinte ao div .gm-style-iw.
      // É este div que agrupa os elementos do botão fechar.
      const iwCloseBtn = iwOuter.next();

      // Aplica o efeito desejado ao botão fechar
      iwCloseBtn.css({
        opacity: '1', // por padrão o botão fechar tem uma opacidade de 0.7
        right:   '55px', top: '19px' // reposicionamento do botão
        //'border-radius': '13px', // efeito circular
        //'box-shadow': '0 0 5px #3990B9' // efeito 3D para salientar o botão
      });

      // A API aplica automaticamente 0.7 de opacidade ao botão após o evento mouseout.
      // Esta função reverte esse evento para o valor desejado.
      iwCloseBtn.mouseout(function() {
        $(this).css({ opacity: '1' });
      });

    });
    infowindow.open($scope.mapViewControl.map, marker);

  };

  this.addEventMap = function() {
    $scope.mapViewControl.map.addListener('click', function() {
      $rootScope.$emit('cleanMarkersOpacity');
      removerAnimacoes();
    });
  };

  this.addEventStreetView = function() {
    const streetView = $scope.mapViewControl.map.getStreetView();
    streetView.addListener('visible_changed', function() {
      if (!this.getVisible()) {
        $timeout(function() {
          self.closeStreetView();
        }, constantSettings.fasterDelayTimeout);
      }
    });
    streetView.addListener('pano_changed', function() {
      $timeout(function() {
        self.openStreetView();
      }, constantSettings.fasterDelayTimeout);

    });
  };

  this.openStreetView = function() {
    $rootScope.appControl.showSearchBar = false;
    $rootScope.appControl.showFloatingControl = false;
    $rootScope.appControl.showAboutBox = false;
    $rootScope.appControl.showDetailsBox = false;
    $rootScope.appControl.showFilterBox = false;
    $rootScope.appControl.showLegendBox = false;
    $rootScope.appControl.showVideoBox = false;
  };

  this.closeStreetView = function() {
    $rootScope.restoreViewControl();
  };

  function getDms(val) {

    let valDeg, valMin, valSec, result;

    val = Math.abs(val); // -40.601203 = 40.601203
    valDeg = Math.floor(val); // 40.601203 = 40
    result = valDeg + "º"; // 40�

    valMin = Math.floor((val - valDeg) * 60); // 36.07218 = 36
    result += valMin + "'"; // 40�36'

    valSec = Math.round((val - valDeg - valMin / 60) * 3600 * 1000) / 1000; // 40.601203 = 4.331
    result += valSec + '"'; // 40�36'4.331"

    return result;
  }

  function ddToDms(lat, lng) {

    let latResult, lngResult, dmsResult;

    lat = parseFloat(lat);
    lng = parseFloat(lng);

    latResult = (lat >= 0) ? 'N' : 'S';
    latResult += getDms(lat);
    lngResult = (lng >= 0) ? 'E' : 'W';
    lngResult += getDms(lng);

    dmsResult = latResult + ' ' + lngResult;

    return dmsResult;
  }

  this.createMarkerList = function() {
    clearAllMarkers();
    $scope.mapViewControl.contracts.forEach(function(contract) {
      contract.coordinates.forEach(function(constructionSite) {
        let marker = null;
        try {
          const lat = constructionSite.nuLatitude;
          const lng = constructionSite.nuLongitude;
          constructionSite.lotes ? constructionSite.lotes.split(',') : [];
          const multiObras = constructionSite.lotes.length > 1;
          const obras = constructionSite.lotes ? constructionSite.lotes.split(',').sort((a, b) => a - b) : constructionSite.lotes;

          const titleDetalhadoMapa = appSettings.config.show.titleDetalhadoMapa;
          let title = contract.name + '\n' + contract.description;
          if (titleDetalhadoMapa) {
            title = contract.name + (multiObras ? '\nObras ' : '\nObra ') + obras + ': (' + lat.toString() + ', ' + lng.toString() + ')\n' + ddToDms(lat, lng);
          }

          marker = new google.maps.Marker({
            position:   new google.maps.LatLng(lat, lng),
            icon:       {
              url:        constructionSite.markerUrl !== '' ? constructionSite.markerUrl : contract.markerUrl,
              size:       new google.maps.Size(40, 60),
              scaledSize: new google.maps.Size(40, 60)
            },
            title:      title,
            id:         contract.id,
            markerId:   constructionSite.uuid,
            cdLote:     constructionSite.cdLote,
            lotes:      constructionSite.lotes ? constructionSite.lotes.split(',') : [],
            coordinate: {
              lat: constructionSite.nuLatitude,
              lng: constructionSite.nuLongitude
            },
            infoWindow: ''
          });
        } catch(err) {
          console.log(err);
          return;
        }
        marker.setMap($scope.mapViewControl.map);
        $scope.mapViewControl.contractsPins.push(marker);
        $timeout;
        self.oms.addMarker(marker);

      });
    });

  };

  this.setMapContracts = function() {
    $scope.mapViewControl.contracts = dataHolderFactory.getContracts();
    self.configureContractsInfo();
    self.createMarkerList();
  };

  this.disableHeatMap = function() {
    console.log('[HeatMap] disableHeatMap chamado');
    $scope.mapViewControl.map.setMapTypeId(google.maps.MapTypeId.ROADMAP);
    ($scope.mapViewControl.heatMap) && $scope.mapViewControl.heatMap.setMap(null);
    self.setMapContracts();
  };

  this.configureHeatMap = function(data) {
    console.log('[HeatMap] configureHeatMap iniciado, pins atuais:', $scope.mapViewControl.contractsPins.length);
    self.cleanMap();
    ($scope.mapViewControl.heatMap) && $scope.mapViewControl.heatMap.setMap(null);
    const heatMapData = [];
    angular.forEach(data, function(heatPoint) {
      heatMapData.push({
        location: new google.maps.LatLng(heatPoint.coordinate.latitude, heatPoint.coordinate.longitude),
        weight:   heatPoint.value
      })
    });
    try {
      $scope.mapViewControl.map.setMapTypeId(google.maps.MapTypeId.SATELLITE);
      // google.maps.visualization.HeatmapLayer foi removida pelo Google na
      // versao 3.65 da Maps JS API; a camada agora e desenhada em canvas por
      // heatMapOverlayFactory (google.maps.OverlayView).
      $scope.mapViewControl.heatMap = heatMapOverlayFactory.create({
        map:    $scope.mapViewControl.map,
        data:   heatMapData,
        radius: constantSettings.heatMapRadius
      });
      console.log('[HeatMap] camada criada com', heatMapData.length, 'pontos');
    } catch(err) {
      console.error('[HeatMap] erro ao criar camada:', err);
    }
  };
  this.cleanMap = function() {
    if ($scope.mapViewControl.contractsPins.length > 0) {
      angular.forEach($scope.mapViewControl.contractsPins, function(contactPin) {
        contactPin.setMap(null);
      });
    }
  };

  this.configureContractsInfo = function() {
    const contracts = dataHolderFactory.getContracts();
    if (!contracts.length) {
      $scope.mapViewControl.showContractsInfo = false;
      return;
    }
    $scope.mapViewControl.contractsListSize = contracts.length;
    $scope.mapViewControl.totalContractsValue = 0;
    angular.forEach(dataHolderFactory.getContracts(), function(contract) {
      $scope.mapViewControl.totalContractsValue += contract.amount;
    });
    $scope.mapViewControl.showContractsInfo = true;
  };

  $rootScope.$on('closeHeatMap', function() {
    self.disableHeatMap();
  });

  $rootScope.$on('contractUpdated', function(event, contract) {
    prepareViewForDetailsByContracts(contract);
    animaMarcadoresPorContrato(contract);
  });

  $rootScope.$on('showingOnMap', function(event, constructionObra) {
    const obra = {
      nuTitulo: constructionObra.contractId,
      cdLote:   constructionObra.id,
      roads:    constructionObra.roads
    };
    $scope.appControl.animaTodasObra = false;
    animaMarcadoresPorObra(obra);
    //	$scope.mapViewControl.map.panTo(new google.maps.LatLng(coordinate.latitude, coordinate.longitude));
    //	self.setZoomOnClick();
  });

  var defaultCallbackPosition = function(position) {
    try {
      $scope.mapViewControl.map.panTo(position);
      $scope.mapViewControl.map.setZoom(appSettings.getDefaultZoom());
    } catch(err) {
      console.log(err);
    }
    overlappingService.loadOverlapping().then(function() {
      self.setMapContracts();
    });

  };

  $rootScope.$on('applyFilters', function() {
    limparLinhas();
    if (!angular.isDefined($scope.mapViewControl)) {
      $scope.mapViewControl = objectMakerFactory.viewObjectControlForMap();
      parameterFactory.initParameters(constantSettings.systems.SMO).then(() => {
        self.configureView();
      });
      return;
    }
    self.getCurrentPosition(defaultCallbackPosition);
  });

  $rootScope.$on('centerMapOnMe', function() {
    self.getCurrentPosition(function(position) {
      try {
        closeCurrentInfoWIndows();
        $scope.mapViewControl.map.panTo(position);
        $scope.mapViewControl.map.setZoom(appSettings.getDefaultZoom());
      } catch(err) {
        console.log(err);
      }
    });
  });

  $rootScope.$on('zoomParaConsulta', function() {
    try {
      $scope.mapViewControl.map.setZoom(constantSettings.searchZoom);
    } catch(err) {
      console.log(err);
    }
  });

  $rootScope.$on('didSelectPlace', function(event, position) {
    try {
      $scope.mapViewControl.map.setCenter(position);
      $scope.mapViewControl.map.setZoom(appSettings.getDefaultZoom());
    } catch(err) {
      console.log(err);
    }
  });

  $rootScope.$on('didSelectPredictionPlace', function(event, prediction) {
    $scope.mapViewControl.serviceMap.getDetails({ placeId: prediction.place_id }, function(place, status) {
      try {
        $scope.mapViewControl.map.setCenter(new google.maps.LatLng(place.geometry.location.lat(), place.geometry.location.lng()));
        $scope.mapViewControl.map.setZoom(appSettings.getDefaultZoom());
        (!$scope.$$phase) && $scope.$apply();
      } catch(err) {
        console.log.error(err);
      }
    });
  });

  $rootScope.$on('updateMapForLayer', function(event, layer, heatMapContext) {
    if (layer === 'HEAT_MAP') {
      $scope.applyHeatMap(heatMapContext);
      return;
    }
    self.disableHeatMap();
    layer = layer || dataHolderFactory.getCurrentLayer();
    dataHolderFactory.updateCurrentLayer(layer);
    $scope.mapViewControl.map.setMapTypeId(layer === 'MAP' ? google.maps.MapTypeId.ROADMAP : google.maps.MapTypeId.SATELLITE);
  });
  $rootScope.$on('cleanMarkersOpacity', function() {
    $scope.mapViewControl.contractsPins.forEach(function(marker) {
      marker.setOpacity(constantSettings.maxOpacity);
    });
  });

  $scope.applyHeatMap = function(context) {
    usSpinnerService.spin('spinner-1');
    dataRequestService.getHeatMapPoints(context.toLowerCase()).then(function(data) {
      usSpinnerService.stop('spinner-1');
      self.configureHeatMap(data);
    }, function(error) {
      usSpinnerService.stop('spinner-1');
      self.disableHeatMap();
      console.log(error);
    });
  };

  let placeIdArray = [];
  let polylines = [];

  const coordenadasToSnapToRoad = function(coordinates) {
    return coordinates.map(function(coordenada) {
      return [coordenada.latitude, coordenada.longitude];
    });
  };

  // Snap a user-created polyline to roads and draw the snapped path

  function runSnapToRoad(groupCoordinates) {
    angular.forEach(groupCoordinates, function(coordinates) {
      $http({
        method: 'GET',
        url:    urlFactory.getGoogleRoadsApiUrl(coordenadasToSnapToRoad(coordinates))
      }).then(function(retorno) {
        processSnapToRoadResponse(retorno.data);
        drawSnappedPolyline();
      }, function() {
        console.log('Não foi possível recuperar coordenadas.');
      });
    });
  }

  // Store snapped polyline returned by the snap-to-road method.

  function processSnapToRoadResponse(data) {
    snappedCoordinates = [];
    placeIdArray = [];
    if (data.snappedPoints) {
      for (let i = 0; i < data.snappedPoints.length; i++) {
        const latlng = new google.maps.LatLng(
          data.snappedPoints[i].location.latitude,
          data.snappedPoints[i].location.longitude);
        snappedCoordinates.push(latlng);
        placeIdArray.push(data.snappedPoints[i].placeId);
      }
    } else {
      console.log('Não foi possível tratar coordenadas.');
    }
  }

  function limparLinhas() {
    angular.forEach(polylines, function(polilinha) {
      polilinha.setMap(null);
    });
    polylines = [];
  }

  // Draws the snapped polyline (after processing snap-to-road response).
  function drawSnappedPolyline() {
    const snappedPolyline = new google.maps.Polyline({
      path:          snappedCoordinates,
      strokeColor:   'blue',
      strokeOpacity: 0.5,
      strokeWeight:  6,
      clickable:     false
    });
    snappedPolyline.setMap($scope.mapViewControl.map);
    polylines.push(snappedPolyline);
  }

  this.setContractMarkers = function(contractId) {
    let hasInfoWindow = false;
    $scope.mapViewControl.contractsPins.forEach(function(marker) {
      if ((marker.id !== contractId)) {
        marker.setOpacity(constantSettings.minOpacity);
      } else {
        if (!hasInfoWindow && !$rootScope.appControl.showDetailsBox && marker.markerId === currentMarkerId) {
          //addInfoWindow(marker);
          hasInfoWindow = true;
        }
        marker.setOpacity(constantSettings.maxOpacity);
      }
    });
  };

}

MapController.$inject = ['$rootScope', '$scope', '$timeout', '$compile', 'objectMakerFactory', 'dataHolderFactory', 'googleMapsInitializerFactory', 'heatMapOverlayFactory', 'usSpinnerService',
  'dataRequestService', 'appSettings', 'constantSettings', '$http', 'urlFactory', 'parameterFactory', 'parameterNames', 'overlappingService'];
export default MapController



// WEBPACK FOOTER //
// ./src/app/scripts/controllers/mapController.js